import {useEffect, useState} from "react";
import {getAdminDashboard} from "@corporatesclub/shared";

export type AdminSidebarBadges = {
  orders?: number;
  returns?: number;
};

export function useAdminSidebarBadges(enabled: boolean): AdminSidebarBadges {
  const [badges, setBadges] = useState<AdminSidebarBadges>({});

  useEffect(() => {
    if(!enabled) return;
    getAdminDashboard({period: "today"})
      .then((d) => setBadges({
        orders: d.ordersTotal,
        returns: d.counts.returns
      }))
      .catch(() => {});
  }, [enabled]);

  return badges;
}
